export const downloadToCsv = data => {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement('a');
    link.href = url;
    const formattedFileName = `Bulk_Import_Users_Sample.csv`;
    link.setAttribute('download', formattedFileName);
    document.body.appendChild(link);
    link.click();
    link.remove();
};

export const buildMultipartBody = async (file, boundary) => {
    const encoder = new TextEncoder();
    const parts = [];

    // Start boundary
    parts.push(encoder.encode(`--${boundary}\r\n`));

    // File header
    parts.push(encoder.encode(`Content-Disposition: form-data; name="upload"; filename="${file.name}"\r\n`));
    parts.push(encoder.encode(`Content-Type: ${file.type || 'text/csv'}\r\n\r\n`));

    // File content
    const fileContent = await file.arrayBuffer();
    parts.push(new Uint8Array(fileContent));

    // End boundary
    parts.push(encoder.encode(`\r\n--${boundary}--\r\n`));

    // Combine all parts into single buffer
    const totalLength = parts.reduce((acc, part) => acc + part.byteLength, 0);
    const body = new Uint8Array(totalLength);
    let offset = 0;

    for (const part of parts) {
        body.set(part, offset);
        offset += part.byteLength;
    }

    return body.buffer;
};
